import agent from "./agent";
import {
  ASYNC_START,
  ASYNC_END,
  LOGIN,
  LOGOUT,
  REGISTER,
} from "./constants/actionTypes";

const promiseMiddleware = (store) => (next) => (action) => {
  if (isPromise(action.payload)) {
    store.dispatch({ type: ASYNC_START, subtype: action.type });

    const currentView = store.getState().viewChangeCounter;
    const skipTracking = action.skipTracking;

    action.payload.then(
      (res) => {
        const currentState = store.getState();
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return;
        }
        action.payload = res;

        store.dispatch({ type: ASYNC_END, promise: action.payload });

        store.dispatch({
          type: ASYNC_END,
          subtype: action.type,
          data: action.payload,
        });
      },
      (error) => {
        const currentState = store.getState();
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return;
        }
        
      
        action.error = true;
        action.payload = error;
        if (!action.skipTracking) {
          store.dispatch({ type: ASYNC_END, promise: action.payload });
        }
        store.dispatch({ type: ASYNC_END, subtype: action.type });

        store.dispatch(action);
      }
    );

    return;
  }

  next(action);
};

const localStorageMiddleware = (store) => (next) => (action) => {
  if (action.type === REGISTER || action.type === LOGIN) {
    if (!action.error) {
      if (action.payload.status == 200) {
        window.localStorage.setItem("jwt", action.payload.data[0].auth_token);
        window.localStorage.setItem("UserData", action.payload.data[0]);
        window.localStorage.setItem("isLoggedIn", true);
        window.localStorage.setItem("categories_with_sub_categories", JSON.stringify(action.payload.data[0].categories_with_sub_categories));

        agent.setToken(action.payload.data[0].auth_token);
      }
    }
  } else if (action.type === LOGOUT) {
    window.localStorage.setItem("jwt", "");
    window.localStorage.setItem("UserData", "");
    window.localStorage.setItem("isLoggedIn", false);

    agent.setToken(null);
  }

  next(action);
};

function isPromise(v) {
  return v && typeof v.then === "function";
}

export { promiseMiddleware, localStorageMiddleware };
